(function () {
  const DEFAULT_PROXY = 'https://book.fusionmirror.com/webhook';

  function ready() {
    document.querySelectorAll('[data-mm-course-dates]').forEach(mount);
  }

  function mount(root) {
    const proxy = (root.getAttribute('data-mm-course-proxy') || DEFAULT_PROXY).replace(/\/$/, '');
    const product = root.getAttribute('data-mm-course-product') || '/products/mapping-training';
    const waitlist = root.getAttribute('data-mm-course-waitlist') || '/pages/contact';
    const list = root.querySelector('[data-mm-course-list]');
    const status = root.querySelector('[data-mm-course-status]');
    const empty = root.querySelector('[data-mm-course-empty]');
    const filters = root.querySelector('.course__filters');
    const moreBtn = root.querySelector('[data-mm-course-more]');
    const fallback = root.getAttribute('data-mm-course-fallback') || '';
    const limit = Math.max(1, Number(root.getAttribute('data-mm-course-limit') || 3));
    const introName = root.getAttribute('data-mm-course-intro') || 'Intro to mapping and geomatics';
    const lidarName = root.getAttribute('data-mm-course-lidar') || 'LiDAR scanning';
    let cohorts = [];
    let course = '2';
    let city = 'all';
    let expanded = false;

    function fromPack(pack) {
      const today = new Date().toISOString().slice(0, 10);
      const seats = Number((pack && pack.seats) || 6);
      return ((pack && pack.cohorts) || [])
        .filter(function (row) {
          return row.starts_on >= today;
        })
        .map(function (row) {
          return {
            id: row.id,
            slug: row.slug,
            city: row.city,
            duration_days: row.duration_days,
            starts_on: row.starts_on,
            ends_on: row.ends_on,
            seats: seats,
            seats_left: seats,
            status: 'open',
            product_url:
              '/products/mapping-training?duration=' +
              row.duration_days +
              '&cohort=' +
              encodeURIComponent(row.id)
          };
        });
    }

    function show(rows) {
      cohorts = rows;
      if (filters) filters.hidden = false;
      if (status) status.hidden = true;
      bindFilters();
      render();
    }

    function dateLabel(row) {
      const start = new Date(row.starts_on + 'T12:00:00');
      const end = new Date(row.ends_on + 'T12:00:00');
      const startDay = start.getDate();
      const endDay = end.getDate();
      const month = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(end);
      const year = end.getFullYear();
      const sameMonth = start.getMonth() === end.getMonth();
      const range = sameMonth ? startDay + '-' + endDay + ' ' + month + ' ' + year : row.starts_on + ' to ' + row.ends_on;
      const place = row.city === 'sydney' ? 'Sydney' : 'Melbourne';
      return range + ' · ' + place;
    }

    function filtered() {
      return cohorts
        .filter(function (row) {
          if (Number(row.duration_days) !== Number(course)) return false;
          if (city !== 'all' && row.city !== city) return false;
          return true;
        })
        .sort(function (a, b) {
          return a.starts_on < b.starts_on ? -1 : 1;
        });
    }

    fetch(proxy + '/course-slots', { credentials: 'omit' })
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (!payload || !payload.ok || !Array.isArray(payload.cohorts)) {
          throw new Error((payload && payload.error) || 'Could not load dates');
        }
        show(payload.cohorts);
      })
      .catch(function (err) {
        if (!fallback) {
          if (status) status.textContent = 'Dates did not load. Call 1800 240 410.';
          console.warn('mm-course-dates', err);
          return;
        }
        fetch(fallback, { credentials: 'omit' })
          .then(function (res) {
            return res.json();
          })
          .then(function (pack) {
            show(fromPack(pack));
          })
          .catch(function (err2) {
            if (status) status.textContent = 'Dates did not load. Call 1800 240 410.';
            console.warn('mm-course-dates', err, err2);
          });
      });

    function pressGroup(selector, current) {
      if (!filters) return;
      filters.querySelectorAll(selector).forEach(function (btn) {
        const value = btn.getAttribute('data-course') || btn.getAttribute('data-city');
        btn.setAttribute('aria-pressed', value === current ? 'true' : 'false');
      });
    }

    function bindFilters() {
      if (!filters) return;
      filters.querySelectorAll('button[data-course]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          course = btn.getAttribute('data-course') || '2';
          expanded = false;
          pressGroup('button[data-course]', course);
          render();
        });
      });
      filters.querySelectorAll('button[data-city]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          city = btn.getAttribute('data-city') || 'all';
          expanded = false;
          pressGroup('button[data-city]', city);
          render();
        });
      });
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          expanded = !expanded;
          render();
        });
      }
    }

    function render() {
      const all = filtered();
      const rows = expanded ? all : all.slice(0, limit);
      list.innerHTML = '';
      if (!all.length) {
        if (empty) empty.hidden = false;
        if (moreBtn) moreBtn.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      rows.forEach(function (row) {
        const item = document.createElement('div');
        item.className = 'course__row';
        const open = row.status === 'open' && Number(row.seats_left) > 0;
        const seats = open
          ? row.seats_left + ' of ' + row.seats + ' seats'
          : 'This date is full';
        const href = open
          ? row.product_url ||
            product + '?duration=' + row.duration_days + '&cohort=' + encodeURIComponent(row.id)
          : waitlist;
        const cta = open ? 'Book a seat' : 'Join waitlist';
        const name = Number(row.duration_days) === 3 ? lidarName : introName;
        item.innerHTML =
          '<div class="course__meta"><strong>' +
          escapeHtml(dateLabel(row)) +
          '</strong><div class="course__seats">' +
          escapeHtml(name) +
          ' · ' +
          escapeHtml(seats) +
          '</div></div><a class="course__cta" href="' +
          escapeHtml(href) +
          '">' +
          escapeHtml(cta) +
          '</a>';
        list.appendChild(item);
      });
      if (moreBtn) {
        moreBtn.hidden = all.length <= limit;
        moreBtn.textContent = expanded ? 'Fewer dates' : 'Later dates';
      }
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
